import { Component } from '@angular/core';
import { FileDetailModel, MSMEResponseModel } from '../../../../../shared/models/MSMEUserModel';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Interest } from '../../../../../shared/models/MSMEProfileInterest';
import { ViewapproverremarksComponent } from '../../../viewapproverremarks/viewapproverremarks.component';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent{
  form: FormGroup;
  name = sessionStorage.getItem('name');
  msMeUserName = sessionStorage.getItem('msMeUserName');
  ownersMobileNumber = sessionStorage.getItem('ownersMobileNumber');
  
  organizationType: any[] = [];
  socialCategory: any[] = [];
  interests: any[] = [];
  enterpriseType: any[] = [];

  niclist: any[] = []; 
  nicListDetails: any[] = [];
  nicForm: FormGroup;
  nicEntries: any[] = [];
  nicCode: string | null = null;
  allNICrecord: any[] = [];
  plantUnit: any[] = [];
  showDateOfIncorp: boolean = false;
  showDateOfComm: boolean = false;


  districtsBasedOnState: any[] = [];
  blocksBasedonDistricts: any;

  enterpriseTypes: string[] = [];

  usr_obj!: MSMEResponseModel;
  
  isWhatsAppSelected: boolean = false;
  plantUnits: { plantName: string; plantLocation: string }[] = [];
  
  showIECField: boolean = false;
  selectedPairs: {
    interventionId: any;
    interventionName: string,
    interestId: string,
    interestName: string
  }[] = [];
  uploadError: string | null = null;
  certificateFile: File | null = null;

  documentForm: FormGroup;
  removedDocuments: any[] = [];  

  filteredInterests: Interest[] = [];
  selectedInterests: Interest[] = [];

  lockedInterestIds: number[] = [];
  isLocked?: boolean;

  registrationStatus: boolean = false;
  constructor(
    public dialog: MatDialog,
    private apiService: ApiService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private datePipe: DatePipe)
  {
    this.nicForm = this.fb.group({
      nicCode: ['', Validators.required],
      sectorName: ['', Validators.required],
      divisionName: ['', Validators.required],
      groupName: ['', Validators.required],
      className: ['', Validators.required],
      subClassName: ['', Validators.required]
    });

    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(100), Validators.pattern(this.commonService.emailPattern)]),
      nameOfEnterprise: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithHypenCommaSlash)]),
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      typeOfEnterprise: new FormControl(null, [Validators.required]),
      typeofOrganization: new FormControl(null, [Validators.required]),
      ownersMobileNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.commonService.mobilePattern)]),
      isWhatsAppEnabled: new FormControl(false),
      alternateContactNumber: new FormControl('', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.commonService.mobilePattern)]),
      gender: new FormControl('', [Validators.required]),
      socialCategory: new FormControl(null, [Validators.required]),
      areYouAPersonWithDisabilities: new FormControl(false, [Validators.required]),
      nicCode: new FormControl(null, [Validators.minLength(3), Validators.maxLength(10)]),
      //areYouAnExporter: new FormControl('', [Validators.required]),
      //iec: new FormControl('', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.commonService.iecCodePattern)]),
      officialAddressOfEnterprise: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern(this.commonService.addressPattern)]),
      districtId: new FormControl(null, [Validators.required]),
      block: new FormControl(null),
      city: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern(this.commonService.city)]),
      pin: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(this.commonService.pincodePattern)]),
      dic: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern(this.commonService.city)]),
      plantUnitName: new FormControl('', [Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.addressPattern)]),
      locationOfPlantUnit: new FormControl('', [Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.addressPattern)]),
      stateName: new FormControl(''),
      status: new FormControl(''),
      remarks: new FormControl(''),
      dateOfIncorporation: new FormControl(''),
      dateOfCommencement: new FormControl(''),
      majorActivity: new FormControl('', [Validators.required]),
      investmentCost: new FormControl(''),
      interestsId: new FormControl(''),
      udyamCertificate: new FormControl('', Validators.required),
      udyamCertificatePath: new FormControl(''),
      documents: this.fb.array([]),
      docName: new FormControl(''),
      docFile: new FormControl(''),
      newDocuments: this.fb.array([this.createDocument()]),
    });

    //const exporterControl = this.form.get('areYouAnExporter');
    //if (exporterControl) {
    //  exporterControl.valueChanges.subscribe(value => {
    //    this.showIECField = value === true;

    //    const iecControl = this.form.get('iec') as FormControl;
    //    if (iecControl) {
    //      if (value === true) {
    //        iecControl.setValidators([Validators.required, Validators.minLength(3)]);
    //      } else {
    //        iecControl.clearValidators();
    //      }
    //      iecControl.updateValueAndValidity();
    //    }
    //  });
    //}

    this.documentForm = this.fb.group({
      docName: ['', Validators.required],  // Document name field is required
      docFile: [null, Validators.required]  // File input is required
    });
  }

  async ngOnInit(): Promise<void> {
    await this.loadOrganizationType();
    await this.loadNICList();
    await this.loadEnterpriseType();
    await this.loadSocialCategory();
    await this.loadInterests();
    await this.loadDistricts();
    this.LoadDetails();
    this.form.get('status')?.disable();
    this.form.get('remarks')?.disable();
    this.form.get('stateName')?.disable();
  }
  
  LoadDetails() {
    var dtoUdyamNumber = { UdyamRegistrationNumber: this.msMeUserName };
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETUSERBYUDYAMNO, dtoUdyamNumber).subscribe(
      (result) => {
        if (result.status) {
          this.usr_obj = result;

          this.form.patchValue({
            email: this.usr_obj.list1[0].email,
            nameOfEnterprise: this.usr_obj.list1[0].nameOfEnterprise,
            name: this.usr_obj.list1[0].name,
            typeOfEnterprise: this.usr_obj.list1[0].typeOfEnterprise,
            ownersMobileNumber: this.usr_obj.list1[0].ownersMobileNumber,
            isWhatsAppEnabled: this.usr_obj.list1[0].isWhatsAppEnabled,
            alternateContactNumber: this.usr_obj.list1[0].alternateContactNumber,
            gender: this.usr_obj.list1[0].gender,
            socialCategory: this.usr_obj.list1[0].socialCategory,
            areYouAPersonWithDisabilities: this.usr_obj.list1[0].areYouAPersonWithDisabilities,
            officialAddressOfEnterprise: this.usr_obj.list1[0].officialAddressOfEnterprise,
            block: this.usr_obj.list1[0].block,
            city: this.usr_obj.list1[0].city,
            pin: this.usr_obj.list1[0].pin,
            dic: this.usr_obj.list1[0].dic,
            stateName: this.usr_obj.list1[0].stateName,
            status: this.usr_obj.list1[0].status,
            remarks: this.usr_obj.list1[0].remarks,
            majorActivity: this.usr_obj.list1[0].majorActivity,
            investmentCost: this.usr_obj.list1[0].investmentCost,            
            districtId: this.usr_obj.list1[0].districtName,
            typeofOrganization: this.usr_obj.list1[0].typeOfOrganization,            
          })
          this.nicEntries = this.usr_obj.list2;
          this.plantUnit = this.usr_obj.list3;
          this.selectedInterests = this.usr_obj.list4;

          this.loadLockedInterests(this.usr_obj.list1[0].udyamRegistrationNumber);

          if (this.usr_obj.list1[0].dateOfCommencement) {
            const dateOfCom = new Date(this.usr_obj.list1[0].dateOfCommencement!);
            const formattedComDate = `${dateOfCom.getFullYear()}-${(dateOfCom.getMonth() + 1).toString().padStart(2, '0')}-${dateOfCom.getDate().toString().padStart(2, '0')}`;
            this.form.get('dateOfCommencement')?.setValue(formattedComDate);
          } else if(this.usr_obj.list1[0].status==='Approved'){
            this.showDateOfComm = true;
            this.form.get('dateOfCommencement')?.setValue('NA');
          }

          if (this.usr_obj.list1[0].dateOfIncorporation) {
            const dateOfInc = new Date(this.usr_obj.list1[0].dateOfIncorporation!);
            const formattedIncDate = `${dateOfInc.getFullYear()}-${(dateOfInc.getMonth() + 1).toString().padStart(2, '0')}-${dateOfInc.getDate().toString().padStart(2, '0')}`;

            this.form.get('dateOfIncorporation')?.setValue(formattedIncDate);

          } else if (this.usr_obj.list1[0].status === 'Approved') {
            this.showDateOfIncorp = true;
            this.form.get('dateOfIncorporation')?.setValue('NA');
          }
        
          const distId = result.list1[0].districtName;
          this.GetBlocks(distId,'edit');

          if (this.usr_obj.list1[0].isWhatsAppEnabled) {
            this.form.get('alternateContactNumber')?.disable();
            this.form.get('alternateContactNumber')?.setValue('N/A');
          }
          //if (!this.usr_obj.list1[0].areYouAnExporter) {
          //  this.form.get('iec')?.disable();
          //}
          this.filteredInterests = this.interests.filter(interest =>
            !this.selectedInterests.some(selected => selected.interestId === interest.interestId)
          );

          this.usr_obj.list5.forEach((file: FileDetailModel) => {
            if (file.documentType === 'Udyam Certificate') {
              this.form.get('udyamCertificatePath')?.setValue(file.documentPath);
              //this.form.get('udyamCertificate')?.setValue('Udyam Certificate');
              //this.form.patchValue({
              //  udyamCertificate: file.documentName,
              //  udyamCertificatePath: file.documentPath
              //});
            } else {
              const documentFormGroup = this.mapDocument();
              documentFormGroup.patchValue({
                id: file.id,
                documentName: file.documentName,
                documentPath: file.documentPath,
                documentType: file.documentType,
                isActive: file.isActive,
                isDeleted: file.isDeleted
              });
              (this.form.get('documents') as FormArray).push(documentFormGroup);
            }
          });

          if (this.usr_obj.list1[0].status === 'Approved' || this.usr_obj.list1[0].status === 'Rejected') {
            this.registrationStatus = true;
            this.disableFormControls();
          } else {
            this.toastrService.warning('Profile verification is under process. You will not have access to other pages until verification completes.');
          }
        } 
      }
    );
  }

  disableFormControls() {    
    this.form.disable();
  }

  async loadOrganizationType(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETORGANIZATIONTYPE).subscribe(
      (result) => {
        if (result.status) {
          this.organizationType = result.data;
        }
      }
    );
  }

  onOrganizationChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.usr_obj.list1[0].typeOfOrganization = selectedValue;
  }

  async loadEnterpriseType(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETENTERPRISETYPE).subscribe(
      (result) => {
        if (result.status) {
          this.enterpriseType = result.data;
        }
      }
    );        
  }

  onEnterpriseChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.usr_obj.list1[0].typeOfEnterprise = selectedValue;
  }

  async loadSocialCategory(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETSOCIALCATEGORY).subscribe(
      (result) => {
        if (result.status) {
          this.socialCategory = result.data;
        }
      }
    );    
  } 
  
  async loadInterests(): Promise<void> {
    
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTEREST.GETLIST).subscribe(
      (result) => {
        if (result.status) {
          this.interests = result.data;
          this.filteredInterests = this.interests.filter(interest =>
            !this.selectedInterests.some(selected => selected.interestId === interest.interestId)
          );
        }
      }
    );      
  }

  async loadDistricts(): Promise<void> {
    const stateId = '58';
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETDISTRICTBASEDONSTATE, { StateID: stateId }).subscribe(
      (result) => {
        if (result.status) {
          this.districtsBasedOnState = result.data;
        }
      }
    );     
  }

  onDistrictChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.usr_obj.list1[0].districtName = selectedValue;
  }

  async GetBlocks(e: any, action: string): Promise<void> {
    var districtId;
    if(action =='select')
      districtId = e.target.value;
    else
      districtId = e;

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.BLOCK.GETBLOCKBASEDONDISTRCIT, { DistrictId: districtId }).subscribe(
      (result) => {
        if (result.status) {
          this.blocksBasedonDistricts = result.data;          
        }
      }
    );  
  }

  onBlockChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.usr_obj.list1[0].block = selectedValue;
  }
  
  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },     
    });
  }

  addPlantUnit() {
    if (this.form.get('plantUnitName')?.invalid || this.form.get('locationOfPlantUnit')?.invalid) {
      this.toastrService.error('Plant/Location is not in correct format');
      return;
    }

    const plantUnitName = this.form.get('plantUnitName')?.value;
    const locationOfPlantUnit = this.form.get('locationOfPlantUnit')?.value;

    if (plantUnitName && locationOfPlantUnit) {
      const normalizedPlantUnitName = plantUnitName.toLowerCase();
      const normalizedLocationOfPlantUnit = locationOfPlantUnit.toLowerCase();

      // Check for duplicates
      const duplicate = this.plantUnits.some(unit =>
        unit.plantName.toLowerCase() === normalizedPlantUnitName && unit.plantLocation.toLowerCase() === normalizedLocationOfPlantUnit
      );

      if (!duplicate) {
        this.plantUnit.push({ plantName: plantUnitName, plantLocation: locationOfPlantUnit });
        
        this.form.get('plantUnitName')?.reset();
        this.form.get('locationOfPlantUnit')?.reset();
      } else {
        this.toastrService.error('This plant unit and location pair already exists.');
      }
    } else {
      this.toastrService.error('Add atleast one plant details');
    }
  }

  onUdyamFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const maxSizeInMB = 10;
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      this.uploadError = null;
      this.form.get('udyamCertificate')?.setErrors(null);
      if (file.type !== 'application/pdf') {
        this.uploadError = 'Only PDF files are allowed.';
        this.certificateFile = null;
      } else if (fileSizeInMB > maxSizeInMB) {
        this.uploadError = 'File size should not exceed 10 MB.';
        this.certificateFile = null;
      } else {
        this.uploadError = null;
        this.certificateFile = file;
        this.form.get('udyamCertificate')?.setValue(file.name);
      }
    }    
  }  
  
  mapDocument(): FormGroup {
    return this.fb.group({
      id:[],
      documentName: [''],
      documentPath: [''],
      documentType: [''],
      isActive :[false],
      isDeleted: [false]
    });
  }
  get f() {
    return this.form.controls;
  }

  createDocument(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],  
      file: [null, Validators.required] 
    });
  }
  get documents(): FormArray {
    return this.form.get('documents') as FormArray;
  }
    
  removeDocument(index: number): void {
    const documentGroup = this.documents.at(index) as FormGroup;
    
    const documentName = documentGroup.get('documentName')?.value;
    if (documentName === this.form.get('udyamCertificate')?.value) {
      this.uploadError = 'You cannot remove the Udyam certificate. Please upload a new one if necessary.';
      return;
    }
    
    documentGroup.patchValue({
      isActive: false,
      isDeleted: true,
    });

    const removedDoc = {
      id: documentGroup.get('id')?.value,
      documentType: documentGroup.get('documentType')?.value,
      documentName: documentGroup.get('documentName')?.value,
      documentPath: documentGroup.get('documentPath')?.value,
      isActive: false,
      isDeleted: true,
    };
    
    this.removedDocuments.push(removedDoc);
    this.documents.removeAt(index); 

    if (this.uploadError && this.documents.length < 5) {
      this.uploadError = ''; 
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  blockManualInput(event: KeyboardEvent): void {
    event.preventDefault();
  }

  openConfirmationDialog(type: string, index: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { type, index }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (type) {
          case 'plantUnit':
            this.removePlantUnit(index);
            break;
          case 'nicEntry':
            this.removeNIC(index);
            break;          
        }
      }
    });
  }
  
  removePlantUnit(index: number) {
    this.plantUnit.splice(index, 1);
  } 

  async generatePDF(): Promise<void> {
    // Call the function to fetch NIC data asynchronously
    await this.getNICDataforPDF();

    // Check if the data is available
    if (!this.allNICrecord || this.allNICrecord.length === 0) {
      return;
    }
    // Create a new jsPDF instance with landscape orientation ('l')
    const doc = new jsPDF('l', 'mm', 'a4'); // 'l' for landscape

    // Add a title to the PDF
    doc.setFontSize(12);
    doc.text('NIC Details', 14, 10);

    // Define the table column headers
    const tableColumn = ['Sr. No', 'NIC Code', 'Sector Code', 'Sector', 'Division', 'Group', 'Class', 'SubClass'];

    // Define the table rows
    const tableRows: any[] = [];

    // Iterate through the fetched data and prepare the table rows
    this.allNICrecord.forEach((item: any, index: number) => {
      const row = [
        index + 1,          // Sr. No
        item.nicCode,       // NIC Code
        item.sectorCode,    // Sector Code
        item.sector,        // Sector
        item.division,      // Division
        item.group,         // Group
        item.class,         // Class
        item.subClass       // SubClass
      ];
      tableRows.push(row);
    });

    // Use autoTable to generate the table
    autoTable(doc, {
      head: [tableColumn], // Column headers
      body: tableRows,     // Table data
      startY: 20,          // Position where the table starts
      theme: 'striped',    // Apply striped rows
      styles: { fontSize: 10 },
      headStyles: { fillColor: [22, 160, 133] }, // Green header
    });

    // Save the generated PDF
    doc.save('NIC_Details.pdf');
  }
  
  toggleInterestSelection(interest: any, event: any): void {
    interest.selected = event.target.checked;
  }
  
  moveSelectedToRight(): void {
    const selected = this.filteredInterests.filter(interest => interest.selected);
    selected.forEach(interest => {
      if (!this.selectedInterests.includes(interest)) {
        this.selectedInterests.push(interest);
      }
      // Remove the interest from the filtered list
      interest.selected = false; // Reset selection
    });
    this.filteredInterests = this.filteredInterests.filter(interest => !selected.includes(interest));
  }
  
  moveSelectedToLeft(): void {
    const deselected = this.selectedInterests.filter(interest => interest.selected);
    deselected.forEach(interest => {
      if (!this.filteredInterests.includes(interest)) {
        this.filteredInterests.push(interest);
      }
    });
    this.selectedInterests = this.selectedInterests.filter(interest => !interest.selected);

  }



  removeUdyamCertificate(): void {    
    this.form.patchValue({
      udyamCertificate: '',
      udyamCertificatePath: '',
    });    
    this.uploadError = 'Udyam certificate is required. Please upload a new one.';
  }

  async loadNICList(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.NIC.GETNICLIST).subscribe(
      (result) => {
        if (result.status) {
          this.niclist = result.data;
        }
      }
    );      
  }

  onNICCodeChange(event: any) {
    const selectedNICCode = event.nicCode;
    this.nicForm.patchValue({
      nicCode: selectedNICCode
    });

    // Optionally, fetch the details for the selected NIC code
    this.callNICCodeDetails(selectedNICCode);
  }

  async callNICCodeDetails(nicCode: string) {   
    const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.NIC.GETSECTORBASEDONNIC, { nicCode }).toPromise();
    if (data.data && Array.isArray(data.data)) {
      const nicDetails = data.data[0];
      this.nicForm.patchValue(nicDetails);
    } 
  }

  addNIC() {
    if (this.nicForm.valid) {

      const selectedNICCode = this.nicForm.value.nicCode;
      const nicItem = this.niclist.find(item => item.nicCode === selectedNICCode);

      if (nicItem) {
        // Create a new entry with the selected nicId and other form values
        const newEntry = {
          nicId: nicItem.nicId,
          nicCode: selectedNICCode,
          sectorName: this.nicForm.value.sectorName,
          divisionName: this.nicForm.value.divisionName,
          groupName: this.nicForm.value.groupName,
          className: this.nicForm.value.className,
          subClassName: this.nicForm.value.subClassName
        };

        // Check if the NIC code already exists in nicEntries
        const exists = this.nicEntries.some(entry => entry.nicCode === newEntry.nicCode);
        if (!exists) {
          // Add the new entry to the nicEntries array
          this.nicEntries.push(newEntry);

          // Reset the form after adding the NIC code
          this.nicForm.reset();
          this.resetNICSelection(); // Reset selection to allow a fresh start
        } else {
          this.nicForm.reset();
          this.toastrService.error('This NIC Code is already added.');
        }
      } else {
        this.toastrService.error('NIC Code not found in the list.');
      }
    } else {
      this.toastrService.error('Select NIC code from the given list.');
    }
  }

  resetNICSelection(): void {
    this.form.get('nicCode')?.setValue('');
  }

  removeNIC(index: number) {
    this.nicEntries.splice(index, 1);

    this.nicForm.patchValue({
      nicCode: '',
      sectorCode: '',
      sectorName: '',
      divisionCode: '',
      divisionName: '',
      groupCode: '',
      groupName: '',
      className: '',
      subClassName: ''
    });
  }

  async getNICDataforPDF(): Promise<void> {
    const response = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.NIC.GETNICDATAFORPDF).toPromise();
        
    if (response && response.data && Array.isArray(response.data)) {
      this.allNICrecord = response.data;      
    } 
  }

  Update(form: any) {
    form.get('udyamRegistrationNumber')?.setValue(this.msMeUserName);    

    if (this.certificateFile || this.form.get('udyamCertificatePath')?.value?.trim()) {
      this.form.get('udyamCertificate')?.clearValidators();
      this.form.get('udyamCertificate')?.updateValueAndValidity();
    }

    if (form.valid) {
      if (this.plantUnit.length === 0) {
        this.toastrService.error('Please add at least one plant unit and location before proceeding');
        return;
      }

      if (this.selectedInterests.length === 0) {
        this.toastrService.error('Please add at least one Interest pair before proceeding');
        return;
      }

      if (this.nicEntries.length === 0) {
        this.toastrService.error('Please add at least one NIC Code before proceeding');
        return;
      }

      const selectedBlockId = form.get('block').value;
      const selectedBlock = selectedBlockId != null ? this.blocksBasedonDistricts.find((type: any) => type.blockId == selectedBlockId) : null;
      

      if (form.get('dateOfIncorporation')?.value) {
        var doi = form.get('dateOfIncorporation')?.value;
        const value = this.datePipe.transform(doi, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
        form.get('dateOfIncorporation')?.setValue(value);
      }
      if (form.get('dateOfCommencement')?.value) {
        var doc = form.get('dateOfCommencement')?.value;
        const value = this.datePipe.transform(doc, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
        form.get('dateOfCommencement')?.setValue(value);
      }

      var formdatavalue = {
        email: this.form.get('email')?.value,
        nameOfEnterprise: this.form.get('nameOfEnterprise')?.value,
        name: this.form.get('name')?.value,
        typeOfEnterprise: this.form.get('typeOfEnterprise')?.value,
        typeofOrganization: this.form.get('typeofOrganization')?.value,
        ownersMobileNumber: this.ownersMobileNumber,
        isWhatsAppEnabled: this.form.get('isWhatsAppEnabled')?.value,
        alternateContactNumber: this.form.get('alternateContactNumber')?.value,
        gender: this.form.get('gender')?.value,
        socialCategory: this.form.get('socialCategory')?.value,
        areYouAPersonWithDisabilities: this.form.get('areYouAPersonWithDisabilities')?.value,
        areYouAnExporter: this.form.get('areYouAnExporter')?.value,
        iec: this.form.get('iec')?.value,
        officialAddressOfEnterprise: this.form.get('officialAddressOfEnterprise')?.value,
        districtId: this.form.get('districtId')?.value,
        block: selectedBlock ? selectedBlock.blockId.toString() : null,
        city: this.form.get('city')?.value,
        pin: this.form.get('pin')?.value,
        dic: this.form.get('dic')?.value,
        dateOfIncorporation: this.form.get('dateOfIncorporation')?.value,
        dateOfCommencement: this.form.get('dateOfCommencement')?.value,
        majorActivity: this.form.get('majorActivity')?.value,
        investmentCost: this.form.get('investmentCost')?.value,
        msmeUserNICCodeDetails: this.nicEntries,
        msmeUserPlantUnitDetails: this.plantUnit,
        msmeUserInterests: this.selectedInterests,
        udyamRegistrationNumber: this.msMeUserName,
        udyamCertificateFile: this.certificateFile,
        removedDocuments: this.removedDocuments,
        newDocuments: this.newDocuments.value,
      };

      const formData = new FormData();
      formData.append('email', this.form.get('email')?.value);
      formData.append('nameOfEnterprise', this.form.get('nameOfEnterprise')?.value);
      formData.append('name', this.form.get('name')?.value);
      formData.append('typeOfEnterprise', this.form.get('typeOfEnterprise')?.value);
      formData.append('typeofOrganization', this.form.get('typeofOrganization')?.value);
      const ownersMobileNumber = this.ownersMobileNumber || '';
      formData.append('ownersMobileNumber',ownersMobileNumber);
      formData.append('isWhatsAppEnabled', this.form.get('isWhatsAppEnabled')?.value);
      formData.append('alternateContactNumber', this.form.get('alternateContactNumber')?.value);
      formData.append('gender', this.form.get('gender')?.value);
      formData.append('socialCategory', this.form.get('socialCategory')?.value);
      formData.append('areYouAPersonWithDisabilities', this.form.get('areYouAPersonWithDisabilities')?.value);
      //formData.append('areYouAnExporter', this.form.get('areYouAnExporter')?.value);
      //formData.append('iec', this.form.get('iec')?.value);
      formData.append('officialAddressOfEnterprise', this.form.get('officialAddressOfEnterprise')?.value);
      formData.append('districtId', this.form.get('districtId')?.value);
      formData.append('block', selectedBlock ? selectedBlock.blockId.toString() : null);
      formData.append('city', this.form.get('city')?.value);
      formData.append('pin', this.form.get('pin')?.value);
      formData.append('dic', this.form.get('dic')?.value);

      var dateOfComm = this.form.get('dateOfCommencement')?.value;
      var dateOfInco = this.form.get('dateOfIncorporation')?.value;
      if (dateOfComm != null) {
        formData.append('dateOfCommencement', this.form.get('dateOfCommencement')?.value);
      }
      else {
        formData.append('dateOfCommencement', '');
      }

      if (dateOfInco != null) {
        formData.append('dateOfIncorporation', this.form.get('dateOfIncorporation')?.value);
      }
      else {
        formData.append('dateOfIncorporation','');
      }

      
      formData.append('majorActivity', this.form.get('majorActivity')?.value);
      formData.append('investmentCost', this.form.get('investmentCost')?.value);
      const msMeUserName = this.msMeUserName || '';
      formData.append('udyamRegistrationNumber', msMeUserName);      

      if (this.certificateFile) {
        formData.append('udyamCertificateFile', this.certificateFile, this.certificateFile.name);
      }
      
      if (this.removedDocuments && this.removedDocuments.length > 0) {
        this.removedDocuments.forEach((doc, index) => {
          if (doc.id) {
            formData.append(`removedDocuments[${index}].id`, doc.id);
          }
        });
      }

      if (this.newDocuments && this.newDocuments.length > 0) {
        this.newDocuments.controls.forEach((control: AbstractControl, index: number) => {
          const docControl = control as FormGroup;
          const name = docControl.get('name')?.value;
          const file = docControl.get('file')?.value;
          if (name) {
            formData.append(`newDocuments[${index}].name`, name);
          }
          if (file) {
            formData.append(`newDocuments[${index}].file`, file, file.name);
          }
        });
      }
      
      if (this.plantUnit && this.plantUnit.length > 0) {
        this.plantUnit.forEach((plant, index) => {
          formData.append(`msmeUserPlantUnitDetails[${index}].plantName`, plant.plantName);
          formData.append(`msmeUserPlantUnitDetails[${index}].plantLocation`, plant.plantLocation);
        });
      }

      if (this.selectedInterests && this.selectedInterests.length > 0) {
        this.selectedInterests.forEach((interest,index) => {
          if (interest.interestId) {
            formData.append(`msmeUserInterests[${index}].interestId`, interest.interestId.toString());
          }
        })
      }

      if (this.nicEntries && this.nicEntries.length > 0) {
        this.nicEntries.forEach((nic, index) => {
          formData.append(`msmeUserNICCodeDetails[${index}].nicCode`, nic.nicCode);
          formData.append(`msmeUserNICCodeDetails[${index}].nicId`, nic.nicId ? nic.nicId: 0);
        });
      }
      
      this.apiService.postRequest(API_ENDPOINTS.MSME.UPDATEUDYAMPROFILE, formData).subscribe(
        (result) => {
          if (result.status) {
            this.toastrService.success(result.message);
            window.location.reload();
          }
        }
      );  
    } else {
      this.form.markAllAsTouched();
      this.toastrService.error("Form is invalid");
      return;
    }
  }

  onWhatsAppChange(event?: any) {
    const iswhatsapp = event.target.checked;
    if (iswhatsapp) {
      this.form.get('alternateContactNumber')?.setValue('');
      this.form.get('alternateContactNumber')?.clearValidators();
      this.form.get('alternateContactNumber')?.disable();
    } else {
      this.form.get('alternateContactNumber')?.setValidators([Validators.required, Validators.pattern(this.commonService.mobilePattern)]);
      this.form.get('alternateContactNumber')?.enable();      
    }
    this.form.get('alternateContactNumber')?.updateValueAndValidity();
  }

  //onExporterChange(event?: any) {
  //  const exporter = event.target.value;
  //  if (exporter==='Yes') {
  //    this.form.get('iec')?.setValidators([Validators.required]);
  //    this.form.get('iec')?.enable();     
  //  } else {
  //    this.form.get('iec')?.setValue('');
  //    this.form.get('iec')?.clearValidators();
  //    this.form.get('iec')?.disable();
  //  }
  //}

  ReloadProfile() {
    window.location.reload();
  }

  // Handle file selection and validation
  onFileChange(event: any, index: number): void {
    const file = event.target.files[0];
    const docControl = this.form.get(`newDocuments.${index}.file`);
    const docNameControl = this.form.get(`newDocuments.${index}.name`);
    
    this.uploadError = null;

    if (file) {
      const maxSizeInMB = 10;
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB

      // Validate file type
      if (file.type !== 'application/pdf') {
        this.uploadError = `Error for document ${index + 1}: Only PDF files are allowed.`;
        docControl?.setValue(null);
        docNameControl?.clearValidators();
      }
      // Validate file size
      else if (fileSizeInMB > maxSizeInMB) {
        this.uploadError = `Error for document ${index + 1}: File size must not exceed 10 MB.`;
        docControl?.setValue(null);
        docNameControl?.clearValidators();
      }
      // Valid file
      else {
        docControl?.setValue(file);
        docNameControl?.setValidators([Validators.required, Validators.pattern(this.commonService.fileNamePattern)]); // Ensure name field is required;
      }
    } else {
      docControl?.setValue(null);
      docNameControl?.clearValidators();
    }
    docNameControl?.updateValueAndValidity();
  }

  addMoreDocuments(): void {    
    if ((this.documents.length + this.newDocuments.length) <= 5) {
      this.newDocuments.push(this.createDocument());
    }
  }

  removeNewDocument(index: number): void {
    this.newDocuments.removeAt(index);
  }
  
  deleteAddressGroup(index: number) {
    const add = this.form.get('newDocuments') as FormArray;
    add.removeAt(index)
  }
  get newDocuments(): FormArray {
    return this.form.get('newDocuments') as FormArray;
  }

  ViewStatusHistory() {
    const dialogRef = this.dialog.open(ViewapproverremarksComponent, {
      width: '600px',      
    });

    dialogRef.afterClosed().subscribe(result => {});

  }

  openFilePreviewDialog(filePath: string, fileName: string): void {
    //var filePath = this.form.get('documentPath')?.value;
    //var fileName = this.form.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  UpdateInterest() {    
    const formData = new FormData();
    if (this.selectedInterests && this.selectedInterests.length > 0) {
      this.selectedInterests.forEach((interest, index) => {
        if (interest.interestId) {
          formData.append(`msmeUserInterests[${index}].interestId`, interest.interestId.toString());
        }
      })
    }
    const ownersMobileNumber = this.ownersMobileNumber || '';
    formData.append('ownersMobileNumber', ownersMobileNumber);
    const msMeUserName = this.msMeUserName || '';
    formData.append('udyamRegistrationNumber', msMeUserName);      
    this.apiService.postRequest(API_ENDPOINTS.MSME.UPDATEINTERESTDETAILSONUDYAMPROFILE, formData).subscribe(
      (result) => {
        if (result.status) {
          this.toastrService.success(result.message);
          window.location.reload();
        }
      }
    );  
    //console.log(this.selectedInterests)
  }


  loadLockedInterests(msmeUserId: string): void {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GET_LOCKED_INTERESTS + "?msmeUserId=" + msmeUserId)
      .subscribe({
        next: (res) => {
          if (res.status && res.data) {
            this.lockedInterestIds = res.data.map((x: any) => x.interestId);
          }

          // After receiving locked IDs → merge disable flag
          this.applyInterestLocks();
        },
        error: () => {
          console.error("Failed to load locked interests");
        }
      });
  }

  applyInterestLocks(): void {

    // Mark locked ones inside selectedInterests list
    this.selectedInterests = this.selectedInterests.map(sel => ({
      ...sel,
      isLocked: this.lockedInterestIds.includes(sel.interestId)
    }));

    // Now update filteredInterests (available interests)
    this.filteredInterests = this.interests.filter(interest =>
      !this.selectedInterests.some(selected => selected.interestId === interest.interestId)
    ).map(unselected => ({
      ...unselected,
      isLocked: this.lockedInterestIds.includes(unselected.interestId)
    }));
  }

}
